module.exports = __webpack_public_path__ + "static/fonts/Fact-BoldItalic.19aa6ac.woff";